import { create } from "zustand";

export interface MCPServer {
  id: string;
  server_url: string;
  server_name: string;
  connection_status: "pending" | "connected" | "disconnected" | "error";
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface FeaturedMCP {
  id: string;
  server_url: string;
  display_name: string;
  description: string;
  icon_url: string;
  docs_url?: string;
  instructions?: string[];
  transport_type: "http" | "sse";
}

export interface MCPConfig {
  id: string;
  name: string;
  displayName: string;
  icon: string;
  serverUrl: string;
  description: string;
  instructions?: string[];
  docsUrl?: string;
  connectionStatus?: "pending" | "connected" | "disconnected" | "error";
  transportType?: "http" | "sse";
}

interface MCPServersStoreState {
  servers: MCPServer[];
  featuredMCPs: FeaturedMCP[];
  isLoading: boolean;
  isFeaturedLoading: boolean;
  error: string | null;
  isModalOpen: boolean;

  setServers: (servers: MCPServer[]) => void;
  setFeaturedMCPs: (mcps: FeaturedMCP[]) => void;
  setLoading: (isLoading: boolean) => void;
  setFeaturedLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  clearServers: () => void;
  openModal: () => void;
  closeModal: () => void;
  updateServerEnabled: (connectionId: string, enabled: boolean) => void;
  removeServer: (connectionId: string) => void;
}

export const mcpServersStore = create<MCPServersStoreState>((set) => ({
  servers: [],
  featuredMCPs: [],
  isLoading: false,
  isFeaturedLoading: false,
  error: null,
  isModalOpen: false,

  setServers: (servers) => set({ servers, isLoading: false, error: null }),

  setFeaturedMCPs: (featuredMCPs) =>
    set({ featuredMCPs, isFeaturedLoading: false }),

  setLoading: (isLoading) => set({ isLoading }),

  setFeaturedLoading: (isFeaturedLoading) => set({ isFeaturedLoading }),

  setError: (error) => set({ error, isLoading: false }),

  clearServers: () => set({ servers: [], error: null }),

  openModal: () => set({ isModalOpen: true }),

  closeModal: () => set({ isModalOpen: false }),

  updateServerEnabled: (connectionId, enabled) =>
    set((state) => ({
      servers: state.servers.map((server) =>
        server.id === connectionId ? { ...server, enabled } : server,
      ),
    })),

  removeServer: (connectionId) =>
    set((state) => ({
      servers: state.servers.filter((server) => server.id !== connectionId),
    })),
}));
